import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import ReduxToastr from "react-redux-toastr";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import App from "./App.jsx";
import "./index.css";
import store from "./store/store.js";
import { BrowserRouter } from "react-router-dom";
import { ClickSoundProvider } from "./components/ClickSoundProvider/ClickSoundProvider.jsx";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import "./security.js";

createRoot(document.getElementById("root")).render(
  // <StrictMode>
  <Provider store={store}>
    <ClickSoundProvider>
      <BrowserRouter>
        <App />
        <ReduxToastr
          timeOut={1200}
          closeOnToastrClick={true}
          preventDuplicates
          position="top-center"
          transitionIn="bounceInDown"
          transitionOut="bounceOutUp"
          closeButton={true}
        />
      </BrowserRouter>
    </ClickSoundProvider>
  </Provider>,
  // </StrictMode>,
);
